import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';

import './Checkbox.less';

export default class Checkbox extends React.Component {
    static displayName = 'Assets.Input.Checkbox';
    static propTypes = {
        id: PropTypes.string,
        name: PropTypes.string,
        label: PropTypes.oneOfType([
            PropTypes.element,
            PropTypes.string
        ]),
        value: PropTypes.oneOfType([
            PropTypes.number,
            PropTypes.string
        ]),
        className: PropTypes.oneOfType([
            PropTypes.array,
            PropTypes.object,
            PropTypes.string
        ]),
        checked: PropTypes.bool,
        onChange: PropTypes.func
    };
    static defaultProps = {
        id: '',
        name: '',
        label: '',
        value: '',
        checked: false,
        onChange: () => {}
    };

    /**
     *
     * @param {Object} props Props
     */
    constructor(props) {
        super(props);
    }

    /**
     *
     * @param {Object} event Event
     */
    onChange(event) {
        this.setState({
            checked: event.target.checked
        }, () => {
            this.props.onChange(this);
        });
    }

    /**
     *
     * @returns {XML} Component
     */
    render() {
        var rootClass = classnames('checkbox', this.props.className);
        return (
            <label className={rootClass}>
                <input type="checkbox" name={this.props.name} value={this.props.value} defaultChecked={this.props.checked}
                    onChange={this.onChange.bind(this)}/><span/>
                {this.props.label}
            </label>
        );
    }
}



// WEBPACK FOOTER //
// ./src/ConsentsLoginModal/Checkbox/index.jsx